import merge from 'lodash/merge';

export const getTranslations = async (locale: string) => {
    const { mylounge, header, footer, cart, upcoming, platformJourney, catalog, homepage, search } =
        await import(
            /* webpackPreload: true */
            /* webpackChunkName: "[request]" */
            `./${locale}.json`
        );

    return {
        ...merge(mylounge, cart, footer, header, platformJourney, catalog, homepage, search),
        upcoming,
        locale: locale.replace('_', '-'),
    };
};
